// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Loqi","notes":"Notes_notes__1SZi0","note":"Notes_note__BcC_5","markdown":"Notes_markdown__3T_AA"};